module.exports = __webpack_public_path__ + "img/fst4fa53ebf.a2ba0d16.png";